<template>
    <div class="worldcup--general-section">
        <a class="back" @click="ClickHideComponent" data-toggle="modal" href="javascript:void(0)">
            <img src="/assets/img/icon-back.svg" alt="back"/>
        </a>
        <b-tabs class="tab-modal">
            <b-tab title="Vòng quay World Cup" active>
                <div class="worldcup--box-tab tab-earn-turn worldcup__banner">
                    <div class="title">KIẾM LƯỢT CHƠI</div>
                    <div class="list-box">
                        <button class="box-item box-login" v-if="!currentUser" @click="moveToWheel('login')">
                            <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/login-action.png`" />
                        </button>
                        <button class="box-item box-recharge" @click="moveToWheel('deposit')">
                            <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/recharge2tr.png`" />
                        </button>
                        <button class="box-item box-bet" @click="moveToWheel('bet')">
                            <img :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-wheel/bet-min.png`" />
                        </button>
                    </div>
                    <div class="title mt-4">THỂ LỆ SỰ KIỆN</div>
                    <Rule class="mobile" />
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import Rule from '~/components/event/worldcup/tabs/rule.vue';

export default {
    components: {
        Rule
    },
    computed: {
        currentUser() {
            return this.$store.state.user;
        }
    },
    methods: {
        ClickHideComponent() {
            this.$emit('hideComponent');
        },
        moveToWheel(item) {
            if (item === 'login') {
                this.$bvModal.show('loginModal');
            }
            if (item === 'bet') {
                this.$router.push('/the-thao');
            }
            if (item === 'deposit') {
                if (this.currentUser) {
                    this.$router.push('/user/deposit?tab=index');
                } else {
                    this.$bvModal.show('loginModal');
                }
            }
        }
    }
};
</script>
